import { useRegisterUserMutation } from "../store/services/loginRegisterQuery";

export const useRegisterPage =()=>{ 
    const 
    [registerUser, 
        {
        data:registerUserData,
        isLoading:registerUserIsLoading,
        isSuccess:registerUserIsSuccess,
        isError:registerUserIsError,
        error:registerUserErrorData
        }
    ] =   useRegisterUserMutation()
return {registerUser,registerUserData,registerUserIsLoading,registerUserIsSuccess,registerUserIsError,registerUserErrorData}
}

